/**
 * DropDown
 * @module components/DropDown
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './DropDown.scss';


/** Class representing the component. */
class DropDown extends Component {

	/**
	 * The render method
	 */
	render () {
		const { children } = this.props;

		return (
			<div className={style.dropDown}>
				{ children }
			</div>
		);
	}
}


DropDown.propTypes = {
	children: PropTypes.array
};


export default DropDown;
